import md5 from "md5";
import { getHostConfig, isGatewayAPI } from "@/utils/request/config";

const addHostSignatureInterceptors = {
  onFulfilled: (config: any) => {
    const timestamp = Date.now();
    config.params = {
      ...config.params
    };
    if (isGatewayAPI(config.url || "")) {
      const HOST_CONFIG = getHostConfig();
      config.baseURL = HOST_CONFIG.gateway.host;
      config.params = {
        ...config.params,
        signature: md5(
          `${HOST_CONFIG.gateway.secretKey}${timestamp}${HOST_CONFIG.gateway.accessKey}`
        ),
        timestamp,
        access_key: HOST_CONFIG.gateway.accessKey
      };
    } else {
      config.baseURL = "";
    }
    return config;
  },
  onRejected: () => {}
};

export default addHostSignatureInterceptors;
